import push from '../../utils/routing';
import { getAssignmentsPath } from './routes';

export const goToAssignments = (spaceId: string) => () =>
  push(getAssignmentsPath(spaceId));
